import { render, staticRenderFns } from "./SalesmanReport.vue?vue&type=template&id=cafb6efe&scoped=true&"
import script from "./SalesmanReport.vue?vue&type=script&lang=js&"
export * from "./SalesmanReport.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanReport.vue?vue&type=style&index=0&id=cafb6efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafb6efe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
